export enum FeatureAnalysisCollapseStateFilterLevel {
  GroupLevel = "GroupLevel",
  SubGroupLevel = "SubGroupLevel",
  FeatureLevel = "FeatureLevel",
}
